import { useI18nContext } from '@/i18n/i18n-react';
import { cn } from '@/lib/utils';

/**
 * Marks a visual that shows the edition's sample data instead of the
 * store's (NEWS-25): never a made-up number without it.
 */
export function SampleBadge({ className }: { className?: string }) {
  const { LL } = useI18nContext();
  return (
    <span
      className={cn(
        'inline-flex h-5 items-center rounded-full bg-white/[.14] px-2 text-[10.5px] font-bold uppercase tracking-[0.08em] text-[#CFE0FF]',
        className
      )}
    >
      {LL.whatsNew.sample()}
    </span>
  );
}
